import { render, staticRenderFns } from "./ActivePhdThesis.vue?vue&type=template&id=2c0793ba&"
import script from "./ActivePhdThesis.vue?vue&type=script&lang=js&"
export * from "./ActivePhdThesis.vue?vue&type=script&lang=js&"
import style0 from "./ActivePhdThesis.vue?vue&type=style&index=0&id=2c0793ba&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports